import { createMetadataGenerator } from '@ui/lib/seo'
import { ENV } from '../env'

export const { generateScopedMetadata } = createMetadataGenerator({
  siteName: ENV.SITE_NAME,
  siteUrl: ENV.SITE_URL,
  isStaging: ENV.IS_STAGING
})
